import { Component, inject } from '@angular/core';
import { InputFieldComponent } from './../../form/input/input-field.component';
import { ModalService } from '../../../services/modal.service';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../../ui/modal/modal.component';
import { ButtonComponent } from '../../ui/button/button.component';
import { AuthService, CurrentUser } from '../../../services/auth.service';

@Component({
  selector: 'app-user-meta-card',
  imports: [
    CommonModule,
    ModalComponent,
    InputFieldComponent,
    ButtonComponent,
  ],
  templateUrl: './user-meta-card.component.html',
  styles: ``
})
export class UserMetaCardComponent {

  constructor(public modal: ModalService) {}

  private auth = inject(AuthService);

  isOpen = false;
  openModal() { this.isOpen = true; }
  closeModal() { this.isOpen = false; }

  // View model populated from logged-in user; defaults for missing fields
  user = {
    firstName: '',
    lastName: '',
    role: '',
    location: '',
    avatar: '/images/user/owner.jpg',
    social: {
      facebook: '',
      x: '',
      linkedin: '',
      instagram: '',
    },
    email: '',
    phone: '',
    bio: '',
  };

  private mapFromCurrentUser(u: CurrentUser | null) {
    const username = u?.username ?? '';
    const parts = username.split(' ').filter(Boolean);
    const firstName = parts[0] ?? username;
    const lastName = parts.slice(1).join(' ');
    this.user.firstName = firstName;
    this.user.lastName = lastName;
    this.user.email = u?.email ?? '';
    this.user.role = (u?.roles && u.roles.length > 0) ? u.roles[0] : '';
    // keep other fields as empty/defaults
  }

  ngOnInit() {
    this.auth.user$.subscribe(u => this.mapFromCurrentUser(u));
  }

  handleSave() {
    // Handle save logic here
    console.log('Saving changes...');
    this.modal.closeModal();
  }
}
